import React, { useState } from 'react';
import { toast } from 'sonner';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Label } from './ui/label';
import { apiClient } from '../lib/api';
import { HOME } from '../constants/testIds';

export default function LeadForm({ compact = false }) {
    const [form, setForm] = useState({ name: '', email: '', phone: '', travelers: 2, message: '' });
    const [sending, setSending] = useState(false);

    const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

    const submit = async (e) => {
        e.preventDefault();
        if (!form.name || !form.email) {
            toast.error('Please share your name and email so we can reach you.');
            return;
        }
        setSending(true);
        try {
            await apiClient.post('/leads', { ...form, travelers: Number(form.travelers) || 1 });
            toast.success("Thanks! Your concierge will reach out within 24 hours.");
            setForm({ name: '', email: '', phone: '', travelers: 2, message: '' });
        } catch (_) {
            toast.error('Something went wrong. Try again.');
        } finally {
            setSending(false);
        }
    };

    return (
        <form
            onSubmit={submit}
            data-testid={HOME.leadForm}
            className={`bg-brand-surface border border-white/10 rounded-2xl p-6 sm:p-8 ${compact ? '' : 'tracing-beam'}`}
        >
            <div className="text-xs uppercase tracking-[0.25em] text-brand-aqua mb-2">Get your quote</div>
            <h3 className="font-display text-2xl sm:text-3xl font-bold tracking-tight uppercase mb-6">
                Start planning <span className="font-serif-italic font-medium text-brand-gold">today</span>
            </h3>
            <div className="grid sm:grid-cols-2 gap-4">
                <Field label="Name *"><Input data-testid="lead-name" value={form.name} onChange={(e) => set('name', e.target.value)} className="bg-transparent border-white/15" /></Field>
                <Field label="Email *"><Input data-testid="lead-email" type="email" value={form.email} onChange={(e) => set('email', e.target.value)} className="bg-transparent border-white/15" /></Field>
                <Field label="Phone"><Input data-testid="lead-phone" value={form.phone} onChange={(e) => set('phone', e.target.value)} className="bg-transparent border-white/15" /></Field>
                <Field label="Travelers"><Input data-testid="lead-travelers" type="number" min={1} value={form.travelers} onChange={(e) => set('travelers', e.target.value)} className="bg-transparent border-white/15" /></Field>
            </div>
            <div className="mt-4">
                <Field label="Anything we should know?">
                    <Textarea data-testid="lead-message" rows={3} value={form.message} onChange={(e) => set('message', e.target.value)} className="bg-transparent border-white/15" placeholder="Bachelorette in Cabo, mid-July, 12 girls…" />
                </Field>
            </div>
            <Button data-testid={HOME.leadSubmit} type="submit" disabled={sending} className="btn-sunset w-full mt-6 rounded-full h-12 font-semibold uppercase tracking-wider">
                {sending ? 'Sending…' : 'Get Free Quote'}
            </Button>
            <p className="text-[11px] text-white/40 mt-3 text-center">We respond within 24 hours. No spam — ever.</p>
        </form>
    );
}

function Field({ label, children }) {
    return (
        <div className="space-y-2">
            <Label className="text-xs uppercase tracking-widest text-white/50">{label}</Label>
            {children}
        </div>
    );
}
